
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/PrivacyPolicy",
      function () {
        return require("private-next-pages/PrivacyPolicy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/PrivacyPolicy"])
      });
    }
  